import React from 'react';

export interface LogoIconProps extends React.SVGProps<SVGSVGElement> {
  variant?: 'classic' | 'two-tone';
  color?: string;
  accentColor?: string;
}

export const LogoIcon: React.FC<LogoIconProps> = ({
  variant = 'classic',
  color = 'currentColor',
  accentColor = '#D98A1F',
  className = 'h-8 w-8',
  ...props
}) => {
  const isTwoTone = variant === 'two-tone';
  const topAndBaseColor = isTwoTone ? accentColor : color;

  return (
    <svg
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Tales Logo"
      {...props}
    >
      {/* Top pediment */}
      <rect x="0" y="0" width="56" height="9" rx="2" fill={topAndBaseColor} />
      {/* Capital taper */}
      <path d="M8 9 L48 9 L42 16 L14 16 Z" fill={color} />
      {/* Shaft */}
      <rect x="19" y="16" width="18" height="32" fill={color} />
      {/* Flutes */}
      <path
        d="M24 18 V46 M32 18 V46"
        stroke="#ffffff"
        strokeOpacity="0.35"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* Base steps */}
      <rect x="10" y="48" width="36" height="4" rx="1" fill={topAndBaseColor} />
      <rect x="6" y="52" width="44" height="5" rx="1" fill={topAndBaseColor} />
    </svg>
  );
};

export interface LogoProps {
  variant?: 'classic' | 'two-tone';
  showText?: boolean;
  subtext?: string;
  className?: string;
  iconClassName?: string;
}

export const Logo: React.FC<LogoProps> = ({
  variant = 'classic',
  showText = true,
  subtext,
  className = '',
  iconClassName = 'h-8 w-8 text-primary',
}) => {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoIcon variant={variant} className={iconClassName} />
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-bold text-base tracking-tight text-foreground">
            Tales
          </span>
          {subtext && (
            <span className="text-[10px] text-muted-foreground uppercase font-medium mt-0.5">
              {subtext}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
